import * as React from "react";
import { makeStyles } from "@mui/styles";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";

const useStyles = makeStyles(theme => ({
  iconRadioButtonContainer: {
    display: "flex",
    alignItems: "center"
  },
  icon: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    marginRight: theme.spacing(1)
  }
}));

const CustomizationAreaRadioList = ({
  iconMethod,
  onSelect,
  options,
  selectionId
}) => {
  const classes = useStyles();

  const handleRadioButtonOnChange = event => {
    onSelect(event.target.id);
  };

  return options.map(({ id, label, icon }) => (
    <div className={classes.iconRadioButtonContainer} key={id}>
      <div className={classes.icon}>{iconMethod(icon)}</div>
      <FormControlLabel
        value={label}
        control={
          <Radio
            checked={selectionId === id}
            id={id}
            color="primary"
            name="customization-area-radio-button"
            onChange={handleRadioButtonOnChange}
            value={label}
          />
        }
        label={label}
      />
    </div>
  ));
};

export default CustomizationAreaRadioList;
